<template>
  <div class="chatContent-container" v-loading="loading">
    <div class="main-container">
      <h3>{{ parmsM.currentMan }}与{{ parmsM.withMan || '--' }}的聊天摘要</h3>
      <h4>{{ parmsM.date }} {{ parmsM.label }}</h4>
      <div class="dangan-row">
        <li class="dangan-title" v-if="form.archivesInfos">
          <h1>{{ form.archivesInfos.ctmName }}</h1>
          <h2>{{ form.archivesInfos.ctmCode }}</h2>
          <span>{{ form.archivesInfos.mtyName }}</span>
        </li>
        <li class="tab-area" v-if="form.archivesInfos">
          <div v-for="(item, index) in form.tags" :key="index" class="tab-item">
            <div class="line" v-if="item.tagAi">
              <div class="line-l" :style="` backgroundColor:${item.tagColor}`"></div>
              <div class="line-r" :style="` backgroundColor:${item.tagColor}`"></div>
            </div>
            <span class="title-name" :style="`color:${item.tagAi ? '#FFFFFF' : '#000000'};backgroundColor:${item.tagColor
              }`
              ">
              {{ item.tagName }}
            </span>
          </div>
        </li>
        <span class="not-data" v-if="!form.archivesInfos">未绑定档案</span>

      </div>
      <div v-if="form.responseData" v-html="form.responseData" style="white-space: pre-wrap;margin-top: 10px;"> </div>
      <span class="not-data" style="margin-top: 100px;" v-else>暂无数据</span>
    </div>
    <div class="btn-row" @click="viewChat">
      <span>查看聊天记录</span>
    </div>
    <ChatContentDia @chatClose="chatClose" ref="ChatContentDiaRef" v-if="chatContentDiaShow" />
  </div>
</template>
<script>
import { summaryViewApi } from "@/api/chatChartSupervise.js";
import ChatContentDia from "@/views/chat/chatChartSupervise/components/ChatContentDia.vue";
export default {
  components: { ChatContentDia },
  props: {
    rowData: {
      type: Object,
      default: null,
    },
    parmsM: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      loading: false,
      form: {
        archivesInfos: {
          /**客户姓名 */
          ctmName: "",
          /**客户卡号 */
          ctmCode: "",
          /**会员卡名称 */
          mtyName: "",
        },
        /**客户院内标签 */
        tags: [],
        responseData: "",
      },
      /** 控制聊天记录弹窗显示隐藏 */
      chatContentDiaShow: false,
    };
  },
  mounted() {
    this.getDetailsData();
  },
  methods: {
    /**获取 聊天摘要数据 */
    async getDetailsData() {
      this.loading = true;
      const res = await summaryViewApi(
        {
          staffId: this.rowData.staffUserId,
          externalUserId: this.rowData.externalUserId,
          chatDate: new Date(this.parmsM.date).getTime(),
        },
        localStorage.getItem("Authorization")
      );
      this.loading = false;
      if (res.error.code == 200 && res.data) {
        this.objectAssignVal(this.form, res.data);
      }
    },

    objectAssignVal(options, assignObj, filterKeyArr) {
      if (typeof options == "object" && typeof assignObj == "object") {
        if (
          filterKeyArr &&
          Object.prototype.toString.call(filterKeyArr) != "[object Array]"
        ) {
          console.warn("入参结构异常6，解构赋值失败");
          return;
        }
        const CopyObj = JSON.parse(JSON.stringify(assignObj));
        for (const key in options) {
          if (Object.prototype.hasOwnProperty.call(options, key)) {
            if (
              filterKeyArr &&
              filterKeyArr.some((v) => {
                return v == key;
              })
            ) {
              // 过滤
            } else {
              key in CopyObj ? (options[key] = CopyObj[key]) : "";
            }
          }
        }
        return options;
      } else {
        console.warn("入参结构异常，解构赋值失败");
      }
    },

    /** 点击查看聊天记录触发 */
    viewChat() {
      this.chatContentDiaShow = true;
      this.$nextTick(() => {
        this.$refs.ChatContentDiaRef.init(this.parmsM, this.rowData);
      });
    },

    /** 关闭弹窗触发 */
    chatClose() {
      this.chatContentDiaShow = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.not-data {
  width: 100%;
  display: block;
  text-align: center;
}

.line {
  position: relative;
  width: 20px;
  /* 容器宽度 */
  height: 2px;
  /* 线条高度 */
  background-color: transparent;
  /* 背景透明 */
}

.line-l {
  position: absolute;
  left: 0;
  height: 1px;
  width: 20px;
  transform: rotate(45deg);
}

.line-r {
  position: absolute;
  left: 0;
  height: 1px;
  width: 20px;
  transform: rotate(135deg);
}

p,
li,
h4,
h1,
h2,
h3 {
  list-style: none;
  padding: 0;
  margin: 0;
}

.chatContent-container {
  background-color: #ffff;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  padding: 24px 16px 0 16px;
  height: 500px;
  display: flex;
  flex-direction: column;

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 8px;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    overflow: hidden;
    box-sizing: border-box;
    background: rgba(38, 132, 255, 1);
  }

  .main-container {
    flex: 1;
    overflow: auto;

    h3 {
      color: rgba(18, 25, 36, 1);
      font-size: 16px;
      font-weight: 700;
      line-height: 23px;
    }

    h4 {
      color: rgba(96, 98, 102, 1);
      font-size: 12px;
      font-weight: 400;
    }

    .dangan-row {
      margin-top: 12px;
      padding: 12px;
      border-radius: 4px;
      background-color: rgba(243, 244, 245, 1);

      .dangan-title {
        display: flex;
        align-items: center;
        gap: 12px;

        h1 {
          font-size: 16px;
          color: rgba(18, 25, 36, 1);
          font-weight: 700;
        }

        h2 {
          font-size: 14px;
          color: rgba(18, 25, 36, 1);
          font-weight: 400;
        }

        span {
          font-size: 14px;
          color: rgba(237, 123, 47, 1);
          font-weight: 500;
        }
      }

      .tab-area {
        display: flex;
        flex-wrap: wrap;
        gap: 4px;
        margin-top: 10px;

        .tab-item {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;

          .title-name {
            border-radius: 4px;
            font-size: 12px;
            font-weight: 400;
            color: #0e264e;
            padding: 0 8px;
            line-height: 24px;
          }
        }
      }
    }

    p {
      overflow: auto;
      margin-top: 16px;
      color: rgba(28, 31, 35, 1);
      font-size: 14px;
      font-weight: 400;
      margin-bottom: 16px;
    }
  }

  .btn-row {
    height: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-top: 1px solid #dee2ee;
    cursor: pointer;

    span {
      display: block;
      line-height: 32px;
      width: fit-content;
      padding: 0 22px;
      border-radius: 4px;
      font-size: 14px;
      background-color: rgba(41, 121, 255, 1);
      color: #ffff;
    }
  }
}
</style>
